import api from '@/helpers/api.js';

/**
 * Gets the link to the search on the shop page.
 *
 * @param {String} [query] - The given search query.
 *
 * @returns {String}
 */
export default function getShopSearchLink(query = '') {
  return api.getUrl('shop-search-products', {
    query: encodeURIComponent(query) || '',
  });
}
